import { render, staticRenderFns } from "./AccountSettings.vue?vue&type=template&id=4b3971e0&"
import script from "./AccountSettings.vue?vue&type=script&lang=js&"
export * from "./AccountSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/orca/workspaces/DIA-3dprima_v2/task-50584/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b3971e0')) {
      api.createRecord('4b3971e0', component.options)
    } else {
      api.reload('4b3971e0', component.options)
    }
    module.hot.accept("./AccountSettings.vue?vue&type=template&id=4b3971e0&", function () {
      api.rerender('4b3971e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/myAccount/AccountSettings.vue"
export default component.exports